import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  winState: 'entry',
  showLoader: false,
  modalOpen: false,
  modalId: null,
  steps: null,
  created: null,
  couponUrl: '',
  wentForIt: '',
  isTransitioning: false,
  shareTitle: 'Discover the Sweeter, Yellow Kiwi',
  shareDescriptionFB: 'Let your taste wander with Zespri’s yellow kiwi, then wander into new experiences for a chance to win a $15,000 grand prize.',
  shareDescriptionTW: 'Wander into the adventurous world of Zespri’s yellow kiwi. It’s sweeter than the green kind and packed with tropical flavor.',
  shareDescriptionPN: 'Wander to the adventurous world of Zespri’s yellow kiwi with sweeter-than-green tropical flavor.',

  shareTitleActivation: 'Wander & Win with Zespri',
  shareDescriptionFBActivation: 'Did you know there was a yellow kiwi? It’s sweeter than the green variety and full of tropical flavor. Journey to the world of Zespri SunGold Kiwifruit!',
  shareDescriptionTWActivation: 'Shake up your everyday routine with Zespri’s Wander & Win challenge for a chance to win a $15,000 grand prize',
  shareDescriptionPNActivation: 'Shake up your everyday routine with the Wander & Win challenge for a chance to win a $15,000 prize.',
  backendUrl: 'https://letyourtastewander.zesprikiwi.com',
  shareUrl: 'https://zesprikiwi.com/wander/',
  shareImage: 'https://zesprikiwi.com/wander/assets/social/socialSharing-site.jpg',
  shareImagePinterest: 'https://zesprikiwi.com/wander/assets/social/socialSharing-pinterest-site.jpg',
  shareImageActivation: 'https://zesprikiwi.com/wander/assets/social/socialSharing-activation.jpg',
  shareImagePinterestActivation: 'https://zesprikiwi.com/wander/assets/social/socialSharing-pinterest-activation.jpg',
  
}

const mutations = {
  goToWinEntry (state) {
    state.winState = 'entry'
  },
  goToWinForm (state) {
    state.winState = 'form'
  },
  goToWinThanks (state) {
    state.winState = 'thanks'
  },
  goToWinReEntry (state) {
    state.winState = 're-entry'
  },
  goToWinEmailEntry (state) {
    state.winState = 'email-entry'
  },
  showLoader (state){
    state.showLoader = true
  },
  hideLoader (state){
    state.showLoader = false
  },
  openModal (state, event) {
    state.modalId = event
    state.modalOpen = true
  },
  closeModal (state) {
    state.modalOpen = false
  },
  setSteps (state, event) {
    state.steps = event
  },
  setCreated (state, event) {
    state.created = event._seconds
  },
  setCouponUrl (state, event) {
    state.couponUrl = event
  },
  setWentForItStatus (state, event) {
    state.wentForIt = event
  },
  startTransition (state) {
    state.isTransitioning = true
  },
  endTransition (state) {
    state.isTransitioning = false
  },
  shareFacebook(state){
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(state.shareUrl)}`,'','left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0')
  },
  shareTwitter(state){
    window.open(`https://twitter.com/intent/tweet?url=${
      encodeURIComponent(state.shareUrl)
    }&text=${encodeURIComponent(state.shareDescriptionTW)
    }&hashtags=ZespriSunGoldKiwifruit`, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0')
  },
  sharePinterest(state){
    window.open(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(state.shareUrl)}&media=${encodeURIComponent(state.shareImagePinterest)}&description=${encodeURIComponent(state.shareDescriptionPN)}`, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0')
  },
  shareTwitterActivation(state){
    window.open(`https://twitter.com/intent/tweet?url=${
      encodeURIComponent(state.shareUrl)
    }&text=${
      encodeURIComponent(state.shareDescriptionTWActivation)
    }&hashtags=WanderWithZespri,ZespriSunGoldKiwifruit`, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0')
  },
  sharePinterestActivation(state){
    window.open(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(state.shareUrl)}&media=${encodeURIComponent(state.shareImagePinterestActivation)}&description=${encodeURIComponent(state.shareDescriptionPNActivation)}`, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0')
  }
}
export default new Vuex.Store({
  state,
  mutations
})